// Carrier-status model (per-individual, per-disease). Projected at render time
// from: existing affected diagnoses, the per-gene clinician `carrierStatus`
// assertion, the terminology gene→disease map, and stored manual obligate
// assertions. See PLAN-carrier-status-pedigree.md.

export const CARRIER_STATUS = Object.freeze({
  affected: 'affected',
  testedCarrier: 'tested_carrier',
  // Carrier known from an external/untracked test or clinical knowledge — no
  // in-TrakGene variant. Distinct from tested (variant-linked) and obligate
  // (pedigree-inferred).
  reportedCarrier: 'reported_carrier',
  obligateCarrier: 'obligate_carrier',
  // Carrier with no stated basis (provenance unspecified) — never silently
  // treated as obligate.
  carrier: 'carrier',
  unaffected: 'unaffected'
});

// Precedence (highest wins): affected > tested_carrier > reported_carrier >
// obligate_carrier > carrier (generic) > unaffected. All carrier kinds render
// the SAME mark; precedence only drives the analysis label.

// The carrier statuses that draw a carrier mark on the node. Use this single
// predicate everywhere a carrier mark is decided, so the four carrier kinds
// never drift apart across call sites.
export const CARRIER_MARK_STATUSES = Object.freeze([
  CARRIER_STATUS.testedCarrier,
  CARRIER_STATUS.reportedCarrier,
  CARRIER_STATUS.obligateCarrier,
  CARRIER_STATUS.carrier
]);

export const isCarrierMark = (status) => CARRIER_MARK_STATUSES.includes(status);

// Gene-level `carrierStatus` values that indicate a (heterozygous) carrier.
// `homozygote-or-compound-heterozygote` is affected-level and reaches the
// pedigree via the affected-diagnosis data, not as a carrier.
export const TESTED_CARRIER_VALUES = Object.freeze(
  new Set(['carrier', 'heterozygote'])
);

// Legend collapses tested + obligate into a single "carrier" presence state.
export const PRESENT_STATE = Object.freeze({
  affected: 'affected',
  carrier: 'carrier'
});
